import '@fortawesome/fontawesome-svg-core/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import { App } from './components';
import './i18n';
import './scss/index.scss';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(app);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export * from './components';
export * from './constants';
export * from './enums';
export * from './validators';
